import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import {
  ControlContainer,
  FormGroup,
  FormGroupDirective,
} from '@angular/forms';

@Component({
    selector: 'discount-iban',
    templateUrl: './discount-iban.component.html',
    styleUrls: ['./discount-iban.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class DiscountIbanComponent implements OnInit {
  @Input() derrors = false;
  @Input() control = 'discountIban';
  @Input() ibans: any[] = []; // List of available IBANs
  selected = '';

  constructor(private controlContainer: FormGroupDirective) {}

  get form() {
    // if the control is nested in a form group
    if (this.control.includes('.')) {
      const keys = this.control.split('.');
      let currentFormGroup: FormGroup = this.controlContainer.form;
      keys.forEach(key => {
        if (currentFormGroup && currentFormGroup.get(key)) {
          const next = currentFormGroup.get(key);
          if (next instanceof FormGroup) {
            currentFormGroup = next;
          }
        }
      });

      return currentFormGroup;
    }

    return this.controlContainer.form?.controls?.[this.control];
  }

  ngOnInit(): void {
    // Pre-select the current IBAN value if it exists
    setTimeout(() => {
      const currentIbanValue = this.form?.get('iban')?.value;
      if (currentIbanValue && this.ibans && this.ibans.length > 0) {
        this.matchAndSelectIban(currentIbanValue);
      }
    }, 100);
  }

  onIbanSelectionChange($event) {
    this.selected = $event.value;
    const ibanSelected = this.ibans.find(iban => iban.iban === this.selected);

    if (ibanSelected) {
      const { id, iban, bankName, bic, holder } = ibanSelected;

      this.form.get('id')?.setValue(id);
      this.form.get('holder')?.setValue(holder);
      this.form.get('bankName')?.setValue(bankName);
      this.form.get('bic')?.setValue(bic);
      this.form.get('iban')?.setValue(iban);
    }
  }

  private matchAndSelectIban(ibanValue: string) {
    if (!ibanValue || !this.ibans || this.ibans.length === 0) {
      return;
    }

    const result = this.ibans.find(
      b => b.iban?.replace(/\s/g, '') === ibanValue?.replace(/\s/g, ''),
    );

    if (result) {
      this.selected = result.iban;
      const { id, iban, bankName, bic, holder } = result;
      this.form.get('id')?.setValue(id, { emitEvent: false });
      this.form.get('holder')?.setValue(holder, { emitEvent: false });
      this.form.get('bankName')?.setValue(bankName, { emitEvent: false });
      this.form.get('bic')?.setValue(bic, { emitEvent: false });
      this.form.get('iban')?.setValue(iban, { emitEvent: false });
    }
  }
}
